import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./style.module.css";
import RebookScreenshot1 from "../../images/processes/rebook0.webp";
import RebookScreenshot0 from "../../images/processes/rebook1.webp";
import RebookScreenshot2 from "../../images/processes/rebook2.webp";
import RebookScreenshot3 from "../../images/processes/rebook3.webp";
import RebookScreenshot4 from "../../images/processes/rebook4.webp";
import RebookScreenshot5 from "../../images/processes/rebook5.webp";
import RebookScreenshot6 from "../../images/processes/rebook6.webp";
import RebookScreenshot7 from "../../images/processes/rebook7.webp";
import RebookScreenshot8 from "../../images/processes/rebook8.webp";

const Rebook = () => {
  const { t } = useTranslation();
  
  const steps = [
    t("processes.rebook.step0"),
    t("processes.rebook.step1"),
    t("processes.rebook.step2"),
    t("processes.rebook.step3"),
    t("processes.rebook.step4"),
    t("processes.rebook.step5"),
    t("processes.rebook.step6"),
    t("processes.rebook.step7"),
    t("processes.rebook.step8")
  ];

  const screenshots = [
    RebookScreenshot0,
    RebookScreenshot1,
    RebookScreenshot2,
    RebookScreenshot3,
    RebookScreenshot4,
    RebookScreenshot5,
    RebookScreenshot6,
    RebookScreenshot7,
    RebookScreenshot8,
  ];

  return (
    <div className={styles.destinationArea}>
      <div className={styles.container}>
        <h1 className={styles.wpoSectionTitle}>Rebook</h1>
        <div className={styles.processContainer}>
          {steps.map((step, index) => (
            <div key={index} className={styles.stepBlock}>
              <div className={styles.stepNumber}>ขั้นตอน {index}</div>
              <p className={styles.stepText}>{step}</p>
              <div className={styles.screenshotWrapper}>
                <img
                  src={screenshots[index]}
                  alt={`Rebook Process Step ${index}`}
                  className={styles.screenshot}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Rebook;